// English articles paired with their existing Danish routes.
const articleLanguagePaths = {
  '/en/blog/refer-a-friend-and-get-free-electricity': '/blogartikelhenvisning',
  '/en/blog/ev-owners-golden-egg': '/elbilejeres-guldaeg',
  '/en/blog/independent-study-smart-charging-co2': '/blogartikelimpactstudy',
  '/en/blog/charging-war-shifts-gear': '/blogartikelladekrig',
  '/en/blog/denmarks-cheapest-electricity-company-nicolaskj': '/blogbestitestnicolaskj',
  '/en/blog/elbiil-dk-test-cheapest-charging-solution': '/blogartikelelbiiltest',
  '/en/blog/everything-about-home-charging-stations': '/blogartikelladestandere',
  '/en/blog/guide-to-home-ev-charging': '/blogartikelguideellader',
  '/en/blog/ev-charger-installation-cost': '/blogartikelinstallationpris',
  '/en/blog/smart-charging-and-grid-balancing': '/blogartikelsmartopladning',
  '/en/blog/how-electricity-tax-refund-works': '/blogartikelrefusion',
  '/en/blog/charger-for-your-ev': '/blogartikelladeboks',
  '/en/blog/best-charging-stations-2025': '/blogartikelbedsteladestandere',
  '/en/blog/zaptec-go-vs-zaptec-go-2-vs-nexblue-edge-2': '/blogartikelsammenligning',
};
export default articleLanguagePaths;